import { render, staticRenderFns } from "./mysetting.vue?vue&type=template&id=2ce685a1&scoped=true"
import script from "./mysetting.vue?vue&type=script&lang=js"
export * from "./mysetting.vue?vue&type=script&lang=js"
import style0 from "./mysetting.vue?vue&type=style&index=0&id=2ce685a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce685a1",
  null
  
)

export default component.exports